(function(){
  function isProduct(){return !!document.querySelector("main[data-template*='product']");}
  function txt(v){return (v||'').toString().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim().toLowerCase();}

  function showAddToCart(){
    if(!isProduct()) return;
    document.querySelectorAll("main[data-template*='product'] add-to-cart-component, main[data-template*='product'] button[name='add'], main[data-template*='product'] .product-form__submit").forEach(function(el){
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('height');
      el.style.removeProperty('min-height');
      el.style.removeProperty('max-height');
      el.style.removeProperty('opacity');
      el.style.removeProperty('pointer-events');
      el.removeAttribute('aria-hidden');
    });
  }

  function hideBuyNow(){
    if(!isProduct()) return;
    var main=document.querySelector("main[data-template*='product']");
    if(!main) return;
    main.querySelectorAll('button,a,div[role="button"]').forEach(function(el){
      var label=txt(el.textContent || el.getAttribute('aria-label'));
      if(label.indexOf('acheter maintenant') !== -1 || label.indexOf('buy now') !== -1 || label.indexOf('buy it now') !== -1){
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
        el.style.setProperty('height','0','important');
        el.style.setProperty('min-height','0','important');
        el.style.setProperty('max-height','0','important');
        el.style.setProperty('margin','0','important');
        el.style.setProperty('padding','0','important');
        el.style.setProperty('overflow','hidden','important');
        el.style.setProperty('opacity','0','important');
        el.style.setProperty('pointer-events','none','important');
        el.setAttribute('aria-hidden','true');
      }
    });
  }

  function run(){showAddToCart();hideBuyNow();}
  document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
  window.addEventListener('load',run);
  window.addEventListener('resize',run);
  var p=false;new MutationObserver(function(){if(p)return;p=true;requestAnimationFrame(function(){p=false;run();});}).observe(document.documentElement,{childList:true,subtree:true});
})();
